import React from "react";
import { CameraIcon, ClipboardCheckIcon, FileTextIcon, MapIcon, PrinterIcon, Table2Icon, BoxIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { tools, ToolKey } from "../../data/content";
const icons: Record<ToolKey, BoxIcon> = {
  sheet: FileTextIcon,
  checklist: ClipboardCheckIcon,
  map: MapIcon,
  matrix: Table2Icon,
  camera: CameraIcon
};
export function Tools() {
  return <section className="bg-navy px-4 py-16 text-white sm:py-24" data-id="element-363" data-mp="28jmpq2odh9kz">
      <div className="mx-auto max-w-4xl" data-id="element-364" data-mp="23smx39maddoa">
        <h2 className="text-balance text-center font-serif text-3xl font-bold leading-tight sm:text-5xl" data-id="element-365" data-mp="23rlgkpmi3yz6">
          Plus, you'll receive these <em className="text-goldlight" data-id="element-366" data-mp="1yrh1n418rcb2">professional tools</em>
        </h2>

        <ul className="mt-10 divide-y divide-white/10 overflow-hidden rounded-3xl bg-navy2 ring-1 ring-white/10" data-id="element-367" data-mp="1tw1q4iqphsht">
          {tools.map(t => {
          const Icon = icons[t.key];
          return <li key={t.key} className="flex gap-4 p-5 sm:p-6" data-id="element-368" data-mp="1kutvcanef9sh">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-goldlight text-navy" data-id="element-369" data-mp="159pwvcp9beox">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-370" data-mp="1a0g5qzww5zod" />
                </span>
                <div data-id="element-371" data-mp="w9b8g4gzxjh7">
                  <h3 className="text-lg font-bold leading-snug" data-id="element-372" data-mp="wa2uanksk2ua">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-white/70" data-id="element-373" data-mp="109lflkgiyfxn">{t.body}</p>
                </div>
              </li>;
        })}
        </ul>

        <p className="mt-6 flex items-center justify-center gap-2 text-center text-[15px] font-semibold text-goldlight" data-id="element-374" data-mp="1nxuus3j8g5ft">
          <PrinterIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-375" data-mp="1ez9e6dxbn0ho" />
          Everything is designed to be downloaded, printed and reused.
        </p>

        <div className="mt-10" data-id="element-376" data-mp="1jwsvjmpbftdu">
          <CTAButton label="I want access to the complete system" tone="dark" data-id="element-377" data-mp="1k06v6n6lhohl" />
        </div>
      </div>
    </section>;
}